import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            为什么800万读者选择妖精漫画网？五大核心优势为你揭晓
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-6 border border-background-200 hover:border-primary-200 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-2.5">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}